var _style, _circle, _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOndoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 477 477",
    style: {
      enableBackground: "new 0 0 477 477"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000100348024760891796630000013456269742943448243_);}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 238.5,
    cy: 238.5,
    r: 238.5
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 71.5,
    y: 71.5,
    width: 334,
    height: 334
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023244166975573882830000011954991160585225117_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000023244166975573882830000011954991160585225117_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M250.3,405.5h-11.8c-92.2,0-167-74.8-167-167s74.8-167,167-167s167,74.8,167,167c0,8.3-0.6,16.4-1.8,24.3 h-23.4c1.3-7.9,2-16,2-24.3c0-79.5-64.4-143.9-143.9-143.9S94.6,159,94.6,238.5S159,382.4,238.5,382.4h85.6 C302.2,395.4,277.2,403.6,250.3,405.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M356.1,357.7H238.5c-65.8,0-119.2-53.4-119.2-119.2s53.4-119.2,119.2-119.2s119.2,53.4,119.2,119.2 c0,8.3-0.9,16.5-2.5,24.3h-23.7c2-7.8,3.1-15.9,3.1-24.3c0-53.1-43-96.1-96.1-96.1s-96.1,43-96.1,96.1s43,96.1,96.1,96.1h137.1 C369.8,342.9,363.3,350.6,356.1,357.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390,309.8H238.5c-39.4,0-71.3-31.9-71.3-71.3s31.9-71.3,71.3-71.3s71.3,31.9,71.3,71.3 c0,8.5-1.5,16.7-4.3,24.3h-25.4c4.2-7.1,6.6-15.4,6.6-24.3c0-26.6-21.6-48.2-48.2-48.2s-48.2,21.6-48.2,48.2s21.6,48.2,48.2,48.2 h160.4C396.5,294.7,393.5,302.4,390,309.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOndoIcon);
export default __webpack_public_path__ + "static/media/ondo_icon.b4d5a5ab1f40e9773d0de9a490baa828.svg";
export { ForwardRef as ReactComponent };